const getDefaultState = () => ({
  seasons: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  suppliers: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  salesTypes: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  packages: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  levels: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  skiTypes: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  season: {
    itemsError: undefined,
    itemsLoading: false,
    saveError: undefined,
    saveLoading: false,
    id: undefined,
    twentySupplierId: undefined,
    name: undefined,
    active: true,
    webActive: true,
    commissionRatio: 0,
    contributionRatio: 0,
    bookDaysBeforeArrival: 0,
    priceAdjustmentValue: 1,
    netOrGross: 'gross',
    salesRule: 'booking',
    informationText: null,
    supplier: undefined,
    newSeasonItem: {
      itemsError: undefined,
      itemsLoading: false,
      saveError: undefined,
      saveLoading: false,
      id: undefined,
      twentySupplierId: undefined,
      name: undefined,
      active: true,
      webActive: true,
      commissionRatio: 0,
      contributionRatio: 0,
      bookDaysBeforeArrival: 0,
      priceAdjustmentValue: 1,
      netOrGross: 'gross',
      salesRule: 'booking',
      informationText: null,
      supplier: undefined,
    },
    periodDates: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      saveLoading: false,
      saveError: undefined,
      newPeriodItem: {
        id: undefined,
        skiRentalSeasonId: undefined,
        arrivalFrom: undefined,
        arrivalTo: undefined,
      },
    },
    personCategories: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      saveLoading: false,
      saveError: undefined,
      newItem: {
        id: undefined,
        skiRentalSeasonId: undefined,
        name: undefined,
        externalName: undefined,
        ageFrom: undefined,
        ageTo: undefined,
      },
    },
    prices: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      saveLoading: false,
      saveError: undefined,
      newPriceItem: {
        id: undefined,
        skiRentalSeasonId: undefined,
        skiRentalSeasonPersonCategoryId: undefined,
        skiRentalSkiTypeId: undefined,
        skiRentalPackageId: undefined,
        skiRentalLevelId: undefined,
        name: undefined,
        externalName: undefined,
        days: [],
      },
      newPriceDayItem: {
        id: undefined,
        skiRentalSeasonPriceId: undefined,
        days: undefined,
        price: undefined,
      },
    },
    priceCombinations: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      defaultNumberOfDays: [2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 14],
      selectedNumberOfDays: [2],
      selectedPersonCategoryIds: [],
      selectedLevelIds: [],
      selectedSkiTypeIds: [],
      selectedPackageIds: [],
      onlyShowSavedPrices: false,
    },
    discounts: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      saveLoading: false,
      saveError: undefined,
      newItem: {
        id: undefined,
        skiRentalSeasonId: undefined,
        bookFrom: undefined,
        bookTo: undefined,
        arrivalFrom: undefined,
        arrivalTo: undefined,
        percentage: undefined,
      },
      personCategories: {
        itemsLoading: false,
        itemsError: undefined,
        saveLoading: false,
        saveError: undefined,
      },
    },
    skiAreas: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      ids: [],
    },
  },
  pickupPlaces: {
    loading: false,
    error: false,
    items: [],
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/ski/rental/defaultState.js